/**
 * External dependencies
 */
import inherits from 'inherits';

export default class UniversalImporterPlan {
    
    constructor(cscom) {
        if (!(this instanceof UniversalImporterPlan)) {
            return new UniversalImporterPlan(cscom);
        }
        this.cscom = cscom;
    }

    list(data) {
        return this.cscom.req.get('/customer-site-api/universal-importer-plans/list', null, data);
    }

    get(data) {
        return this.cscom.req.get('/customer-site-api/universal-importer-plans/view', null, data);
    }    
}
